"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InternalOrOperation = (function () {
    function InternalOrOperation(left, right) {
        this.left = left;
        this.right = right;
    }
    InternalOrOperation.prototype.evaluate = function (resolverFactory) {
        return (this.left.evaluate(resolverFactory) ||
            this.right.evaluate(resolverFactory));
    };
    InternalOrOperation.prototype.describe = function () {
        return "".concat(this.left.describe(), " || ").concat(this.right.describe());
    };
    return InternalOrOperation;
}());
var OrOperation = function (left, right) {
    return new InternalOrOperation(left, right);
};
exports.default = OrOperation;
